import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';
import Img from 'gatsby-image';
var Headline = function Headline(props) {
    return props.link ? /*#__PURE__*/ React.createElement(Link, {
        to: props.link,
        className: classNames('headline', 'headline--link', {
            'headline--left': props.imagePlacement && props.imagePlacement === 'left'
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "headline__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "headline__copy"
    }, /*#__PURE__*/ React.createElement("h1", null, props.copy.headline.span && /*#__PURE__*/ React.createElement("span", null, props.copy.headline.span), props.copy.headline.h1), /*#__PURE__*/ React.createElement("p", null, props.copy.text)), /*#__PURE__*/ React.createElement("div", {
        className: "headline__image"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: props.image.source
    })))) : /*#__PURE__*/ React.createElement("div", {
        className: classNames('headline', {
            'headline--left': props.imagePlacement && props.imagePlacement === 'left'
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "headline__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "headline__copy"
    }, /*#__PURE__*/ React.createElement("h1", null, props.copy.headline.spanLinksTo && /*#__PURE__*/ React.createElement(Link, {
        to: props.copy.headline.spanLinksTo
    }, /*#__PURE__*/ React.createElement("span", null, props.copy.headline.span)), !props.copy.headline.spanLinksTo && props.copy.headline.span && /*#__PURE__*/ React.createElement("span", null, props.copy.headline.span), props.copy.headline.h1), /*#__PURE__*/ React.createElement("p", null, props.copy.text), !!props.copy.link && !props.link && (props.copy.link.outbound ? /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        href: props.copy.link.linksTo
    }, props.copy.link.text) : /*#__PURE__*/ React.createElement(Link, {
        to: props.copy.link.linksTo || ''
    }, props.copy.link.text))), /*#__PURE__*/ React.createElement("div", {
        className: "headline__image"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: props.image.source
    }))));
};
export default Headline;
